import React from "react";
import PropTypes from "prop-types";

import useHub from "data/hub/useHub";

import { HublyMeetingsCard, SyncMeetingsCard } from ".";

function CardMeetings({ client }) {
  const hub = useHub();

  return hub?.preferences?.sync?.shouldSyncMeetings ? (
    <SyncMeetingsCard />
  ) : (
    <HublyMeetingsCard client={client} />
  );
}

CardMeetings.propTypes = { client: PropTypes.object.isRequired };

export default CardMeetings;
